export default "__VITE_ASSET__DvjRR7ED__"